import APIService from '@/services/APIService.js';

export default {
  uploadFile(postData) {
    return APIService.apiCall().post('arquivos/upload', postData, {
      timeout: 60 * 60 * 1000,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  getNameArquivoById(id) {
    return APIService.apiCall().get(`/arquivos/getNameArquivoById/${id}`);
  },
  getHeaderArquivo(postData) {
    return APIService.apiCall().post('/arquivos/getHeaderArquivo', JSON.stringify(postData));
  },
  validarHeaderCSV(arquivoId, postData) {
    return APIService.apiCall().post(`/arquivos/validarHeaderCSV/${arquivoId}`, JSON.stringify(postData));
  },
  getModalArquivos() {
    return APIService.apiCall().get('/arquivos/getModalArquivos');
  },
  getRpaFilesUploadedToday() {
    return APIService.apiCall().get('/arquivos/getRpaFilesUploadedToday');
  },
  baixarRpaFileS3(path, basename, config = {}) {
    return APIService.apiCall().get(`/arquivos/baixarRpaFileS3/${path}/${basename}`, { responseType: 'blob', ...config });
  },
  downloadArquivoById(id, config = {}) {
    return APIService.apiCall().get(`/arquivos/baixarArquivoById/${id}`, { responseType: 'blob', ...config });
  }
};
